import { render } from "./ModalMiniBox.vue?vue&type=template&id=7b3612c3&scoped=true&ts=true"
import script from "./ModalMiniBox.vue?vue&type=script&lang=ts&scoped=true"
export * from "./ModalMiniBox.vue?vue&type=script&lang=ts&scoped=true"

import "./ModalMiniBox.vue?vue&type=style&index=0&id=7b3612c3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b3612c3"]])

export default __exports__